import 'hammerjs';
import { enableProdMode } from '@angular/core';
import { platformBrowserDynamic } from '@angular/platform-browser-dynamic';

import { AppModule } from './app/app.module';
import { environment } from './environments/environment';

import * as Parse from 'parse';

Parse.initialize(environment.PARSE_APP_ID);
(Parse as any).serverURL = environment.serverURL;

if (environment.production) {
  enableProdMode();
} else {
  // for development
  window['Parse'] = Parse;
}

platformBrowserDynamic()
  .bootstrapModule(AppModule)
  .catch(err => console.error(err));
